import React, { useState, useEffect, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import moment from 'moment';

//import history from 'utils/history';

// styles
import './style.scss';

// antd component
import { Radio, Empty, Spin } from 'antd';

// utils
import { getAttendancesOnDate } from 'utils/helpers/helper.generateData';
import { sortByKey, getObjId } from 'utils/helpers/helper.general';

function PresencesListCourses({
  dataSourse,
  selectedDate,
  checkedCourse,
  currentCourse,
  // states
  loading,
  // action
  getCourse,
  // default props
  className,
}) {
  const childClassNames = classNames('presences-list-courses', className);

  const [checkedRadio, setCheckedRadio] = useState(null);

  useEffect(() => {
    !!checkedCourse && setCheckedRadio(null);
    !currentCourse && setCheckedRadio(null);
  }, [checkedCourse, currentCourse]);

  const onChangeRadio = useCallback(
    e => {
      if (e.target.checked) {
        getCourse(e.target.value);
        setCheckedRadio(e.target.value);
      }
    },
    [dataSourse],
  );

  const renderItem = useCallback((item, classAtt, checkedAtt) => {
    return (
      <Radio
        key={getObjId(item)}
        value={getObjId(item)}
        className={`presences-radio-item` + classAtt + checkedAtt}
      >
        <span className={`presences-list-item`}>
          {item?.subject?.color && (
            <span
              className="courses-list-color"
              style={{
                backgroundColor: `${
                  item?.subject?.color
                    ? item?.subject?.color
                    : 'transparent'
                }`,
              }}
            />
          )}

          <span className="list-items-meta">
            <span className="list-items-meta-header">
              {item?.course_time_start && (
                <span className="courses-list-time">
                  {moment(item?.course_time_start).format('HH:mm')}
                </span>
              )}
              {item?.subject?.name && (
                <span className="list-item-meta-title">
                  {item?.subject?.name}
                </span>
              )}
            </span>
            <span className="list-items-description">
              {item?.class_info?.title && (
                <span className="courses-list-class">
                  {item?.class_info?.title}
                </span>
              )}
            </span>
          </span>
        </span>
      </Radio>
    );
  }, []);

  const renderList = useCallback(() => {
    let dataSourseNew =
      dataSourse &&
      dataSourse
        ?.map(el => {
          return {
            ...el,
            title: `<span class="time">${moment(el?.course_time_start).format(
              'HH:mm',
            )}</span> <span class="cours-name">${el?.subject?.name}</span>`,
          };
        })
        .sort(sortByKey('title'));

    return dataSourseNew?.map((item, inx, arr) => {
      const currentAttendanceArr = getAttendancesOnDate(item, selectedDate);
      const att = currentAttendanceArr[0];
      const classAtt =
        getObjId(att?.course) == getObjId(item) ? ' hasAtt' : ' noAtt';
      const checkedAtt =
        getObjId(checkedRadio) == getObjId(item) ? ' checkedRadio' : '';
      return renderItem(item, classAtt, checkedAtt);
    });
  }, [dataSourse, selectedDate, checkedRadio]);

  return (
    <div className={childClassNames}>
      {!loading && (dataSourse || (dataSourse && dataSourse.length > 0)) && (
        <Radio.Group
          className="presences-list-courses__list"
          name={`presences-list-courses`}
          onChange={onChangeRadio}
          defaultValue={null}
          value={getObjId(checkedRadio) || null}
        >
          {renderList()}
        </Radio.Group>
      )}
      {!loading &&
        (!dataSourse || (dataSourse && dataSourse.length == 0)) && (
          <Empty description="Il n'y a pas de cours à cette date." />
        )}
      {loading && <Spin className="tcf-spin" />}
    </div>
  );
}

PresencesListCourses.defaultProps = {
  loading: false,
};
PresencesListCourses.propTypes = {
  dataSourse: PropTypes.oneOfType([
    PropTypes.bool.isRequired,
    PropTypes.array.isRequired,
  ]),
  checkedCourse: PropTypes.oneOfType([
    PropTypes.object.isRequired,
    PropTypes.bool.isRequired,
    PropTypes.string.isRequired,
  ]),
  selectedDate: PropTypes.oneOfType([
    PropTypes.object.isRequired,
    PropTypes.bool.isRequired,
    PropTypes.string.isRequired,
  ]),
  loading: PropTypes.bool,
  getCourse: PropTypes.func,
};

export default PresencesListCourses;
